<!--
  Inline-SVG sparkline used in tile headers and the live status row. No chart
  lib — ~50 LOC; the package has no sparkline. Drawn in the ember with a soft
  fade underneath, per the design pack's chart primitives. Colours are theme
  classes (`stroke-brand`, `fill-brand-soft`), so they follow the tokens.
-->
<script lang="ts">
	import type { AnalyticsTimeBucket } from '../lib/types';

	const {
		series,
		height = 60,
	}: {
		series: AnalyticsTimeBucket[];
		height?: number;
	} = $props();

	const W = 600;
	const H = 100;

	const max = $derived(Math.max(1, ...series.map((b) => b.count)));

	function pointsFor(s: AnalyticsTimeBucket[]): string {
		if (s.length === 0) return '';
		const stepX = W / Math.max(1, s.length - 1);
		return s
			.map((b, i) => {
				const x = i * stepX;
				const y = H - (b.count / max) * (H - 4) - 2;
				return `${x.toFixed(1)},${y.toFixed(1)}`;
			})
			.join(' ');
	}

	const linePoints = $derived(pointsFor(series));
	const areaPath = $derived.by(() => {
		if (series.length === 0) return '';
		const stepX = W / Math.max(1, series.length - 1);
		let d = `M 0,${H} `;
		series.forEach((b, i) => {
			const x = i * stepX;
			const y = H - (b.count / max) * (H - 4) - 2;
			d += `L ${x.toFixed(1)},${y.toFixed(1)} `;
		});
		d += `L ${W},${H} Z`;
		return d;
	});
</script>

<svg
	viewBox="0 0 {W} {H}"
	preserveAspectRatio="none"
	class="block w-full"
	style:height={`${height}px`}
	role="img"
	aria-label="Activity over the selected window"
>
	{#if series.length > 0}
		<path d={areaPath} class="fill-brand-soft" />
		<polyline points={linePoints} fill="none" class="stroke-brand" stroke-width="1.75" stroke-linejoin="round" />
	{/if}
</svg>
